import { IReducerAction } from 'src/interfaces/redux';
import { IStats, IEventsStats } from 'src/interfaces/Stats';
export * from './stats.selectors';

export interface IStatsState {
  stats: IStats;
  events: IEventsStats;
  showStats: boolean;
}

export const statsInitialState: IStatsState = {
  stats: {
    media: {
      droppedVideoFrames: 0,
      totalVideoFrames: 0,
      bandwidth: 0,
      codecs: '-',
      mediaResolution: 0,
      mediaCode: '-',
      choosenResolution: '',
      user: '',
      currentDate: '',
      deviceConnection: '',
    },
    general: {
      viewId: '',
      viewport: 0,
      projectVersion: 0,
      duration: '0s',
      measuredBandwidth: 0,
      volume: 0,
      experimentName: '',
      browserInfo: '',
    },
    buffer: {
      currentTime: '0s',
      bufferStart: 0,
      bufferEnd: 0,
      bufferTimeRemaining: '0s',
    },
    chunks: {
      chunkBitrate: '',
      chunkSize: '',
      chunkURI: '',
    },
  },
  events: {
    PLAY: 0,
    PAUSE: 0,
    SEEKING: 0,
    WAITING: 0,
  },
  showStats: false,
};

export enum StatsActionTypes {
  STATS = 'STATS/STATS',
  EVENTS = 'STATS/EVENTS',

  SHOW_STATS = 'STATS/SHOW_STATS',
  HIDE_STATS = 'STATS/HIDE_STATS',
}

export type IStatsAction = IReducerAction<StatsActionTypes>;

export default function stateReducer(state: IStatsState = statsInitialState, action: IStatsAction) {
  switch (action.type) {
    case StatsActionTypes.STATS:
      return { ...state, stats: action.payload };
    case StatsActionTypes.EVENTS:
      return { ...state, events: action.payload };
    case StatsActionTypes.SHOW_STATS:
      return { ...state, showStats: true };
    case StatsActionTypes.HIDE_STATS:
      return { ...state, showStats: false };
    default:
      return state;
  }
}
